import { render, staticRenderFns } from "./AppealDetails.vue?vue&type=template&id=10953368&"
import script from "./AppealDetails.vue?vue&type=script&lang=js&"
export * from "./AppealDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppealDetails.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports